import { createPortal } from 'react-dom';
import { useRef } from 'react';
import { Transition } from 'react-transition-group';

import { Overlay } from '../../design-system/Modal/Overlay';
import { getDisplayFilters } from '../../resources/filters/selectors';
import { useAppSelector } from '../../shared/redux';

import { Filters } from './Filters';
import s from './Filters.css';

export const FiltersPanel = (): JSX.Element | null => {
    const opened = useAppSelector(getDisplayFilters);
    const nodeRef = useRef<HTMLDivElement>(null);
    const appContainer = document.getElementById('app-container');
    if (!appContainer) {
        return null;
    }

    return createPortal(
        <Transition
            in={opened}
            timeout={{
                enter: 0,
                exit: 300,
            }}
            mountOnEnter
            unmountOnExit
            nodeRef={nodeRef}
        >
            {(status) => (
                <div ref={nodeRef}>
                    <Overlay status={status} className={s.overlay}>
                        <Filters status={status} />
                    </Overlay>
                </div>
            )}
        </Transition>,
        appContainer,
    );
};
